import React from 'react';

import PropTypes from 'prop-types';
import { useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { isEmpty } from 'lodash';

import ReceiptTear from 'assets/images/receipt-tear.png';
import { AUTH_TYPE } from 'modules/partial/constants';
import { Button } from 'modules/common/input';
import { formatCurrency, print } from 'modules/common/utils';

import CartRow, { CartRowHeader } from '../cart/CartRow';
import PrintTemplateV2 from './PrintTemplateV2';
import { useGetDiscountV2, useGetSettings } from '../../hooks';
import Receipt from '../cart/Receipt';

function PrintReceipt({ type, includes, branch, state }) {
  const authType = React.useContext(AUTH_TYPE);
  const { branch_uuid } = useParams() || {};

  const merchantMatch = useRouteMatch('/store-branches/:branch_uuid');
  const adminMatch = useRouteMatch(
    branch_uuid
      ? '/merchants/:merchant_uuid/store-branches/:branch_uuid'
      : '/merchants/:merchant_uuid'
  );

  const locState = useLocation()?.state || {};

  const dispatchReturn = {
    ADMIN: `${adminMatch?.url}/services/pos/order`,
    MERCHANT: branch_uuid
      ? `${merchantMatch?.url}/services/pos/order`
      : '/services/pos/order',
    BRANCH: '/services/pos/order',
  };

  const {
    res,
    cart,
    payment_method,
    amount_tendered,
    change,
    subtotal,
    discounts,
  } = isEmpty(state) ? locState : state;

  const [, , discountIncluded] = useGetDiscountV2(discounts);
  const { chargesList, totalVAT, totalCharge } = useGetSettings();

  const discountValue = discountIncluded?.discountValue(subtotal || 0);
  const discountedSubTotal = discountIncluded?.discountedSubTotal(
    subtotal || 0
  );

  const VAT = +(discountedSubTotal + totalCharge) * (totalVAT / 100);
  const getTotal = discountedSubTotal + totalCharge + VAT;

  const handleOnPrint = () => {
    print('print-template');
  };

  return (
    <div className="flex flex-col flex-1 items-center md:mt-7 p-3 md:p-5 overflow-y-auto overflow-x-hidden">
      <div className="hidden" id="print-template">
        <PrintTemplateV2
          businessName={branch?.business_name}
          branchName={branch?.branch_name}
          businessLogo={branch?.logo_url}
          address={branch?.address_details || branch?.address?.address_details}
          cart={res?.cart}
          includes={includes}
          paymentMethod={payment_method}
          amountTendered={amount_tendered}
          change={change}
          data={{
            subtotal: formatCurrency(subtotal || 0),
            discount: `- ${
              discountIncluded?.hasSelectedDiscount
                ? formatCurrency(discountValue || 0)
                : formatCurrency(0)
            }`,
            chargesList,
            totalVAT,
            VAT: formatCurrency(VAT || 0) || '-',
            total: formatCurrency(getTotal || 0),
          }}
        />
      </div>

      <div className="flex flex-col w-full max-w-[400px] space-y-3 py-5">
        <div className="w-full flex flex-col">
          <img src={ReceiptTear} alt="" className="h-9 w-full" />
          <div className="flex flex-col p-10 pt-5 pb-5 space-y-5 border bg-white border-t-0 border-b-0">
            <div className="space-y-1.5 flex flex-col">
              {/* {branch?.logo_url && (
                <div className="mx-auto">
                  <img
                    src={branch?.logo_url}
                    alt=""
                    className="h-24 object-contain"
                  />
                </div>
              )} */}
              <div className="font-bold text-lg flex flex-wrap justify-center gap-1 text-center">
                <div>{branch?.business_name} </div>
                <div className="text-primary-500">
                  {branch?.branch_name && `- ${branch?.branch_name}`}
                </div>
              </div>
              <div className="text-xs text-gray-500 text-center">
                {branch?.address_details || branch?.address?.address_details}
              </div>
            </div>

            <div className="border-t pt-5 border-dashed space-y-3 overflow-hidden">
              <CartRowHeader withRemove={false} />

              <div className="space-y-1.5 overflow-y-auto max-h-52 pt-1.5 pr-1">
                {cart?.length > 0 ? (
                  cart?.map((item) => (
                    <CartRow
                      data={item}
                      withRemove={false}
                      isWhiteBg
                      withImage={false}
                      withPrice={type !== 'CUSTOMER'}
                      includes={includes}
                    />
                  ))
                ) : (
                  <div className="text-gray-400 text-xs text-center py-4">
                    <i>No items in this order...</i>
                  </div>
                )}
              </div>
            </div>

            <Receipt
              subtotal={subtotal}
              isSmall
              withHrLast={false}
              overrideDiscount={discounts}
            />
          </div>
          <img src={ReceiptTear} alt="" className="h-9 w-full rotate-180" />
        </div>

        <div className="flex items-center gap-2 mx-auto pt-2">
          <Button
            label="Go Back"
            className="btn gray bg-gray-100 font-semibold"
            to={dispatchReturn?.[authType]}
          />
          <Button
            label="Print Receipt"
            className="btn primary font-semibold"
            onClick={handleOnPrint}
          />
        </div>
      </div>
    </div>
  );
}

PrintReceipt.defaultProps = {
  type: 'BRANCH',
  includes: {},
  branch: {},
  state: {},
};

PrintReceipt.propTypes = {
  type: PropTypes.string,
  includes: PropTypes.instanceOf(Object),
  branch: PropTypes.instanceOf(Object),
  state: PropTypes.instanceOf(Object),
};

export default PrintReceipt;
